import { useState } from 'react';
import classes from './AuctionDashCard.module.scss';
import { Divider } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import FavPopover from './FavPopOver';
import { useDispatch } from 'react-redux';
import { setCarDetail } from '../../../../store/reducers/carReducer';

const AuctionDashCard = ({content, favHandler, isFreeTier, onUpgradeClick}) => {
    const dispatch = useDispatch();
    const [isFav, setIsFav] = useState(content.isFavorite);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    
    const navigate = useNavigate();
    
    const displaySnackbar = (message, variant) => {
        enqueueSnackbar(message, {
            variant,
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            },
        });
    };

    const changeFav = (e) => {
        // Prevent the click from bubbling up to the parent card
        e.stopPropagation();
        
        if(isFav){
            displaySnackbar("Removed from Favorites", "info");
        } else {
            displaySnackbar("Added to Favorites", "success");
        }
        
        favHandler(content);
        setIsFav(!isFav);
    }

    const handleFavoriteClick = (e) => {
        // Prevent the click from bubbling up to the parent card
        e.stopPropagation();
        
        if (!isFav) {
            changeFav(e);
        } else {
            setIsPopoverOpen(true);
        }
    };

    const handleConfirmUnfavorite = (confirm, e) => {
        if (e) {
            e.stopPropagation();
        }
        
        if (confirm) {
            changeFav(e || { stopPropagation: () => {} });
        }
        setIsPopoverOpen(false);
    };

    const onCardClickHandler = () => {
        dispatch(setCarDetail(content));
        // Open in new tab instead of navigating in the same tab
        window.open(`/detail/${content._id}`, '_blank');
    };
  
    let vehicleName = content.model + " " + content.makerDetail.maker + " " +  content.makerDetail.model + " " + (content.makerDetail.grade ? content.makerDetail.grade : "");
    
    // Free tier users no longer see delayed content
    const isDelayedContent = false;

    return (
        <div 
            className={`${classes.AuctionDashCard} ${isDelayedContent ? classes.DelayedContent : ''}`}
            onClick={onCardClickHandler}
            role="button"
            tabIndex="0"
            aria-label={`View details for ${vehicleName}`}
            style={{ cursor: 'pointer' }}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    onCardClickHandler();
                }
            }}
        >
            {isDelayedContent && (
                <div className={classes.DelayedBadge}>
                    <span>NEW</span>
                </div>
            )}
            <div className={classes.ImgContainer}>
                <img src={content.vehicleImages[0]} alt={vehicleName} />
                <div className={classes.Bid}>
                    <p>Bid No: {content.bidDetail?.bidNo?.replace(/^No\./, '')}</p>
                </div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.Km}>
                    <p>● {content.mileage}</p>
                </div>
                <h5>{vehicleName}</h5>
                <div className={classes.Info}>
                    <div className={classes.InfoContext}>
                        <div className={classes.InfoIconContainer}>
                        <i className="far fa-star"></i>
                        </div>
                        <p>Grade: {content.inspectionScore}</p>
                    </div>
                    <div className={classes.InfoContext}>
                        <div className={classes.InfoIconContainer}>
                        <i className="fas fa-gavel"></i>
                        </div>
                        <p>{content.bidDetail?.bidSite}</p>
                    </div>
                    
                    {/* Auction time information - VIP feature */}
                    <div className={classes.InfoContext}>
                        <div className={classes.InfoIconContainer}>
                        <i className="far fa-calendar"></i>
                        </div>
                        {isFreeTier ? (
                            <div className={classes.lockedFeature} onClick={(e) => {
                                e.stopPropagation();
                                onUpgradeClick();
                            }}>
                                <i className="fas fa-lock"></i> Auction Time
                            </div>
                        ) : (
                            <p>{content.bidDetail?.bidDate}</p>
                        )}
                    </div>
                </div>
                <Divider orientation='horizontal' />
                <div className={classes.BtnContainer} onClick={(e) => e.stopPropagation()}>
                    <button className={classes.BtnPurple} onClick={onCardClickHandler}>View Details</button>
                    <FavPopover 
                        isOpen={isPopoverOpen}
                        onClose={(e) => {
                            if (e) e.stopPropagation();
                            setIsPopoverOpen(false);
                        }}
                        onConfirm={handleConfirmUnfavorite}
                        isFav={isFav}
                        onButtonClick={handleFavoriteClick}
                        buttonClass={!isFav ? classes.BtnWhite : classes.BtnPurple}
                    />
                </div>
            </div>
        </div>
    )
}

export default AuctionDashCard;